import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import VipBox from './vipBox';
import ShopBox from './shopBox';

class VSNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { vipData, shopData },
        } = this.props;

        return (
            <div className={styles.box}>
                <div className="clearfix">
                    <VipBox content={vipData} />
                    <ShopBox content={shopData} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(VSNews);
